export enum MimeCategory {
  Text = 'text',
  Image = 'image',
  Code = 'code',
  Markdown = 'markdown',
  Pdf = 'pdf',
  Raw = 'raw',
  Folder = 'folder',
  Office = 'office',
}

export interface FileOperations {
  download?: boolean
  edit?: boolean
  delete?: boolean
  copy?: boolean
  move?: boolean
  convertManual?: boolean
  convertTemplate?: boolean
}

export interface FileType {
  actions: FileOperations
  category: MimeCategory
  icon?: string
}

export interface Category {
  viewMode?: boolean
  icon: string
  indexing?: boolean
}
